import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { ExpandableComponent } from './expandable.component';
/**
 * Sample usage:
 *
 *     <expandable2 expandableTitle="Title">
 *         Lorem ipsum dolor
 *     </expandable2>
 */
@Component({
    selector: 'expandable2',
    templateUrl: './expandable2.html',
    standalone: true,
    imports: [ZippyModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Expandable2Component extends ExpandableComponent {}
